import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "login-container" }
const _hoisted_3 = { class: "login-card" }

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import type { LoginRequest, LoginResponse } from '@virtual-care/shared'
import { requireEnv } from '@virtual-care/shared'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const router = useRouter()
const username = ref('')
const password = ref('')
const loading = ref(false)
const errorMessage = ref('')

const apiBaseUrl = requireEnv(process.env.VUE_APP_API_BASE_URL, 'VUE_APP_API_BASE_URL')

const handleLogin = async () => {
  loading.value = true
  errorMessage.value = ''

  try {
    const requestBody: LoginRequest = {
      username: username.value,
      password: password.value,
    }

    const response = await fetch(`${apiBaseUrl}/api/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    })

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Login failed' }))
      throw new Error(error.error || 'Invalid username or password')
    }

    const data = (await response.json()) as LoginResponse

    localStorage.setItem('vc_jwt_token', data.access_token)
    localStorage.setItem('vc_username', data.username)
    localStorage.setItem('vc_display_name', data.displayName)
    localStorage.setItem('vc_caregiver_id', data.caregiverId)

    router.push('/')
  } catch (error) {
    console.error('Login failed:', error)
    errorMessage.value = error instanceof Error ? error.message : 'Login failed. Please try again.'
  } finally {
    loading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "login-header" }, [
          _createElementVNode("h1", { class: "login-title" }, "Virtual Care"),
          _createElementVNode("p", { class: "login-subtitle" }, "Nurse Console")
        ], -1)),
        _createElementVNode("form", {
          onSubmit: _withModifiers(handleLogin, ["prevent"]),
          class: "login-form"
        }, [
          _createVNode(_component_v_text_field, {
            modelValue: username.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
            label: "Username",
            type: "text",
            variant: "outlined",
            "error-messages": errorMessage.value ? [errorMessage.value] : [],
            required: "",
            autocomplete: "username"
          }, null, 8, ["modelValue", "error-messages"]),
          _createVNode(_component_v_text_field, {
            modelValue: password.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
            label: "Password",
            type: "password",
            variant: "outlined",
            "error-messages": errorMessage.value ? [errorMessage.value] : [],
            required: "",
            autocomplete: "current-password"
          }, null, 8, ["modelValue", "error-messages"]),
          _createVNode(_component_v_btn, {
            type: "submit",
            color: "primary",
            loading: loading.value,
            disabled: !username.value || !password.value,
            block: "",
            size: "large"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Log In ", -1)
            ]))]),
            _: 1
          }, 8, ["loading", "disabled"])
        ], 32)
      ])
    ])
  ]))
}
}

})